// extracted by mini-css-extract-plugin
module.exports = {"root":"LinkRemovalWarning_root__wfNSo","buttonWrapper":"LinkRemovalWarning_buttonWrapper__a0Nol"};